import { render } from "./SkeletonProductRecommendationItem.vue?vue&type=template&id=4f585e25"
import script from "./SkeletonProductRecommendationItem.vue?vue&type=script&lang=js"
export * from "./SkeletonProductRecommendationItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__